import { render, staticRenderFns } from "./PdfTest.vue?vue&type=template&id=248fb2df&scoped=true"
import script from "./PdfTest.vue?vue&type=script&lang=js"
export * from "./PdfTest.vue?vue&type=script&lang=js"
import style0 from "./PdfTest.vue?vue&type=style&index=0&id=248fb2df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fb2df",
  null
  
)

export default component.exports